export const analyticsActions = {
  WordPairs: {
    btnStart: 'WordPairs-btnStart',
    btnPremium: 'WordPairs-btnPremium',
    btnAmazon: 'WordPairs-btnAmazon',
    btnGoogle: 'WordPairs-btnGoogle',
    btnApple: 'WordPairs-btnApple'
  },
  WordPairsInitial: {
    btnStart: 'WordPairsInitial-btnStart',
    btnPremium: 'WordPairsInitial-btnPremium'
  },
  LetterJumble: {
    btnStart: 'LetterJumble-btnStart',
    btnPremium: 'LetterJumble-btnPremium',
    btnAmazon: 'LetterJumble-btnAmazon',
    btnGoogle: 'LetterJumble-btnGoogle',
    btnApple: 'LetterJumble-btnApple'
  },
  WordSearch: {
    btnStart: 'WordSearch-btnStart',
    btnPremium: 'WordSearch-btnPremium',
    btnAmazon: 'WordSearch-btnAmazon',
    btnGoogle: 'WordSearch-btnGoogle',
    btnApple: 'WordSearch-btnApple'
  },
  WpmTest: {
    btnStart: 'WpmTest-btnStart',
    btnPremium: 'WpmTest-btnPremium',
    btnAmazon: 'WpmTest-btnAmazon',
    btnGoogle: 'WpmTest-btnGoogle',
    btnApple: 'WpmTest-btnApple'
  },
  SchulteLetters: {
    btnStart: 'SchulteLetters-btnStart',
    btnPremium: 'SchulteLetters-btnPremium',
    btnAmazon: 'SchulteLetters-btnAmazon',
    btnGoogle: 'SchulteLetters-btnGoogle',
    btnApple: 'SchulteLetters-btnApple'
  },
  SchulteMix: {
    btnStart: 'SchulteMix-btnStart',
    btnPremium: 'SchulteMix-btnPremium',
    btnAmazon: 'SchulteMix-btnAmazon',
    btnGoogle: 'SchulteMix-btnGoogle',
    btnApple: 'SchulteMix-btnApple'
  },
  SchulteNumbers: {
    btnStart: 'SchulteNumbers-btnStart',
    btnPremium: 'SchulteNumbers-btnPremium',
    btnAmazon: 'SchulteNumbers-btnAmazon',
    btnGoogle: 'SchulteNumbers-btnGoogle',
    btnApple: 'SchulteNumbers-btnApple'
  }
}